import React from 'react';
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const quickLinks = [
        { name: 'Ana Sayfa', href: '#home' },
        { name: 'Ürünler', href: '#products' },
        { name: 'Hakkımızda', href: '#about' },
        { name: 'Nereden Alınır', href: '#where-to-buy' },
        { name: 'İletişim', href: '#contact' }
    ];

    const handleScrollToSection = (sectionId) => {
        if (sectionId.startsWith('#')) {
            const element = document.getElementById(sectionId.substring(1));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };

    return (
        <footer className="relative bg-gradient-to-br from-gray-900 via-black to-gray-800">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-5">
                <div className="w-full h-full" style={{
                    backgroundImage: 'radial-gradient(circle at 25% 25%, #ad2831 0%, transparent 50%), radial-gradient(circle at 75% 75%, #540b0e 0%, transparent 50%)',
                    backgroundSize: '100px 100px'
                }}></div>
            </div>

            <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
                {/* Main Footer Content */}
                <div className="py-12 lg:py-16">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-16 max-w-5xl mx-auto">

                        {/* Company Info */}
                        <div className="space-y-6">
                            <div className="space-y-4">
                                <img
                                    src="/Images/zenon-white-logo.png"
                                    alt="Zenon Gaming Logo"
                                    className="h-12 w-auto"
                                />
                                <p className="text-gray-300 font-montserrat text-sm leading-relaxed">
                                    Yeni nesil gaming bilgisayarlarıyla oyun dünyasında fark yaratıyoruz.
                                    Güçlü performans, kaliteli donanım ve üstün tasarımla gaming deneyiminizi zirveye taşıyoruz.
                                </p>
                            </div>

                            {/* Contact Info */}
                            <div className="space-y-3">
                                <div className="flex items-center space-x-3 text-gray-300 hover:text-white transition-colors">
                                    <FiMail className="text-[#ad2831]" size={18} />
                                    <span className="text-sm font-montserrat">info@zenon.com.tr</span>
                                </div>
                                <div className="flex items-center space-x-3 text-gray-300 hover:text-white transition-colors">
                                    <FiPhone className="text-[#ad2831]" size={18} />
                                    <span className="text-sm font-montserrat">+90 (342) 324 04 04</span>
                                </div>
                                <div className="flex items-start space-x-3 text-gray-300 hover:text-white transition-colors">
                                    <FiMapPin className="text-[#ad2831] mt-1" size={18} />
                                    <span className="text-sm font-montserrat">
                                        Mücahitler, 52054. Sk., 27500
                                        <br /> Şehitkamil/Gaziantep
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Quick Links */}
                        <div className="space-y-6">
                            <h3 className="text-white font-montserrat font-bold text-lg uppercase tracking-wide">
                                Hızlı Linkler
                            </h3>
                            <ul className="space-y-3">
                                {quickLinks.map((link, index) => (
                                    <li key={index}>
                                        <button
                                            onClick={() => handleScrollToSection(link.href)}
                                            className="text-gray-300 hover:text-[#ad2831] transition-colors duration-300 font-montserrat text-sm block hover:translate-x-2 transform transition-transform"
                                        >
                                            {link.name}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="border-t border-white/10 py-6">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                        <div className="text-gray-400 font-montserrat text-sm">
                            © {currentYear} ZENON Gaming. Tüm hakları saklıdır.
                        </div>
                        <div className="flex flex-wrap justify-center md:justify-end space-x-6 text-sm">
                            <button className="text-gray-400 hover:text-[#ad2831] transition-colors font-montserrat">
                                Gizlilik Politikası
                            </button>
                            <button className="text-gray-400 hover:text-[#ad2831] transition-colors font-montserrat">
                                Kullanım Koşulları
                            </button>
                            <button className="text-gray-400 hover:text-[#ad2831] transition-colors font-montserrat">
                                Çerez Politikası
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#ad2831] to-transparent opacity-30"></div>
        </footer>
    );
};

export default Footer;